import { hasMinRole } from "@/lib/constants";
import type { FeatureFlagKey } from "@/lib/feature-flags";
import type { ChangelogEntry } from "./types";

// Lista bor i `entries.ts`. Denne fila eier FILTRERINGEN, og er det hjelp-temaet
// «Nytt i Revehiet» ankrer. Re-eksporten holder importstien uendret for alt som
// alt leser `CHANGELOG_ENTRIES` herfra.
export { CHANGELOG_ENTRIES } from "./entries";

export type FlagResolver = (key: FeatureFlagKey) => boolean;

/**
 * Filtrerer punkter og seksjoner på rolle og feature-flagg. Tomme seksjoner
 * og tomme oppføringer fjernes, så en ekstern bruker aldri ser en tom
 * «Innstillinger»-overskrift.
 */
export function visibleEntries(
  entries: readonly ChangelogEntry[],
  role: string | null | undefined,
  isFlagOn: FlagResolver,
): ChangelogEntry[] {
  const effectiveRole = role ?? "user";
  const result: ChangelogEntry[] = [];
  for (const entry of entries) {
    const sections = entry.sections
      .filter((s) => !s.minRole || hasMinRole(effectiveRole, s.minRole))
      .map((s) => ({
        ...s,
        items: s.items.filter(
          (i) =>
            (!i.minRole || hasMinRole(effectiveRole, i.minRole)) &&
            (!i.featureFlag || isFlagOn(i.featureFlag)),
        ),
      }))
      .filter((s) => s.items.length > 0);
    if (sections.length > 0) result.push({ ...entry, sections });
  }
  return result;
}

/**
 * Popupen vises når det finnes en synlig utrulling brukeren ikke har
 * kvittert for. Kalleren sender nyeste synlige UTRULLING, ikke nyeste
 * systemrapport-oppføring (VIB-2832): per-PR-loggen gir aldri popup. `seenId` er `users.changelog_seen_id` (NULL = aldri sett).
 * `undefined` betyr at raden ikke er lastet ennå, og da venter vi.
 */
export function shouldShowChangelogPopup(
  latest: { id: string } | undefined,
  seenId: string | null | undefined,
): boolean {
  if (!latest) return false;
  if (seenId === undefined) return false;
  return seenId !== latest.id;
}
